import React, { useState, useEffect } from 'react'
import { BeneficiosCarrusel } from './BeneficiosCarrusel';
import { Beneficio } from './Beneficio';
import PropTypes from 'prop-types';
import '../../css/components/BannerInicio/BannerInicio.css';

export const BannerInicio = ({ beneficios, imagen, texto, titulo }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeCallback = () => {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', resizeCallback);

    return () => {
      window.removeEventListener('resize', resizeCallback);
    };
  });

  const seccionBeneficios = beneficios.map((beneficio, i) => {
    return <Beneficio key={i} {... beneficio} />
  });

  return (
    <div className='beneficios-inicio__layout'>
      <div className='beneficios-inicio__contenedor'>
        {width >= 800 && (
          <div className='beneficios-inicio__imagen'>
            <div>
              <img src={imagen} alt="imagen banner" />
            </div>
          </div>
        )}

        <div className='beneficios-inicio__titulo'>
          <span>{titulo}</span>
        </div>

        <div className='beneficios-inicio__texto'>
          <span>{texto}</span>
        </div>

        <div className='beneficios-inicio__beneficios'>
          {width < 800 ? (
            <BeneficiosCarrusel beneficios={beneficios}/>
          ) : (
            seccionBeneficios
          )}
        </div>
      </div>
    </div>
  );
}

BannerInicio.propTypes = {
  beneficios: PropTypes.arrayOf(PropTypes.shape({
    texto: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    urlIcono: PropTypes.string.isRequired
  })).isRequired,
  imagen: PropTypes.string.isRequired,
  texto: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/BannerInicio/BannerInicio.js